import styled from 'styled-components';

export const FooterContainer = styled.footer`
    background-color: #000;

`

export const FooterWrapper = styled.div`
    padding: 48px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1100px;
    margin: 0 auto;
`

export const SocialMedia = styled.section`
    max-width: 1000px;
    width: 100%;
 `
export const SocialMediaWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    max-width: 1100px;
    margin: 40px auto 0 auto;

    @media screen and (max-width: 820px) {
        flex-direction: column;
    }
 `

export const Signed = styled.small`
    color: #fff;
    margin-bottom: 20px;
`

export const SocialIcons = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 70px;
`

export const SocialIconsLinks = styled.a`
    color: #fff;
    font-size: 26px;
`